




















































































































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { UserOnlineCourseDetails } from '@/api/models';

@Component({})
export default class SignIndex extends Vue {
  unionid: string = '';
  onlineFinished: boolean = false;
  onlineCountHours: number = 0;
  onlineList: any = [];
  onlineLoading: boolean = false;
  tabActive: any = 0;
  loading: boolean = false;
  finished: boolean = false;
  activeNames: any = [];
  listData: any = [];
  showYear: boolean = false;
  columns: any[] = [];
  containerStyle: any = {
    backgroundImage: 'url(' + require('@/images/学时底图@2x.png') + ')',
    backgroundRepeat: 'round',
    backgroundSize: '100%',
    paddingBottom: '15px',
  };
  allHours: number = 0;
  classNumbers: number = 0;
  query: any = {
    year: null,
  };
  onlineQuery: {
    userIds?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
  } = {
    userIds: '',
    startDate: '',
    endDate: '',
  };
  page: any = {
    pageIndex: 1,
    pageSize: 30,
  };
  trainingSchedules: any = [];
  onConfirm(val: any) {
    this.showYear = false;
    if (val == '全部') {
      this.query.year = null;
      this.onlineQuery.startDate = null;
      this.onlineQuery.endDate = null;
    } else {
      this.query.year = parseInt(val);
      this.onlineQuery.startDate = val + '-01-01';
      this.onlineQuery.endDate = val + '-12-31';
    }

    this.getListData();
    this.getAllHours();
    this.getCountHours();
    this.onlineOnLoad();
  }
  onCancel() {
    this.showYear = false;
  }
  onChange() {}
  selectYear() {
    this.showYear = true;
  }
  async onLoad() {
    this.getListData();
    this.getAllHours();
  }

  async getStuInfo() {
    const { data } = await api.AccountApp.getUserPersonalInfo_GET();
    this.onlineQuery.userIds = data.unionid;
    this.getCountHours();
  }

  /**线上总学时 */
  async getCountHours() {
    try {
      if (this.onlineQuery.userIds) {
        const { data } = await api.AccountApp.getStudentOnlineCountHours_GET(this.onlineQuery);
        if (data) this.onlineCountHours = data[0].hours;
      }
    } catch (error) {
      console.log('%c [ error ]-166', 'font-size:13px; background:pink; color:#bf2c9f;', error);
    }
  }

  /**线上学习记录 */
  async onlineOnLoad() {
    try {
      if (this.onlineQuery.userIds) {
        const { data } = await api.AccountApp.getStudentOnlineHoursDetails_GET({
          ...this.onlineQuery,
          pageIndex: this.page.pageIndex++,
        });
        this.onlineList.push(...data.rows);

        if (!data || !data.rows || data.rows.length === 0 || data.rows.length === data.total) {
          this.onlineFinished = true;
        }
        this.onlineLoading = false;
      }
    } catch (error) {
      this.onlineFinished = true;
      this.onlineLoading = false;
    } finally {
      this.onlineLoading = false;
    }
  }

  mounted() {
    this.getStuInfo();
    this.getYearDay();
  }

  getYearDay() {
    let year = new Date().getFullYear();
    let arr = [];
    for (let i = 0; i < 10; i++) {
      arr.push(year--);
    }
    const data = arr.sort((a, b) => b - a);
    this.columns = ['全部', ...data];
  }

  async collapseChange(e: any, id: string) {
    if (this.activeNames.includes(id)) {
      this.activeNames = this.activeNames.filter(e => e != id);
    } else {
      try {
        const data = await api.PlanOfClass.findTrainingSchedules_GET({ classId: id });
        this.trainingSchedules = data;

        if (!this.activeNames.includes(id)) this.activeNames.push(id);
      } catch (error) {
        console.log('%c [ error ]-132', 'font-size:13px; background:pink; color:#bf2c9f;', error);
      }
    }
  }

  async getListData() {
    this.loading = true;
    try {
      const { data } = await api.AccountApp.getMyTrainRecordsByYear_GET({ year: this.query.year });
      this.listData = data;
      //折叠面板展开绑定展开项id
      if (this.listData) {
        // this.listData.forEach((item: any) => {
        //   this.activeNames.push(item.id);
        // });
        //已培训班次
        this.classNumbers = this.listData.length;
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
  //获取已获得学时
  async getAllHours() {
    const { data } = await api.AccountApp.getSumDays_GET({ year: this.query.year });
    this.allHours = data.days;
  }
  //计算日程安排中所有课程总学时
  computeTrainAllHours(object: any) {
    let sum = 0;
    object.forEach((item: any) => {
      sum += item.hours;
      return sum;
    });
    return sum;
  }
}
